module.exports = __webpack_public_path__ + "static/media/react.550522a4.svg";